import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../context/AuthContext';

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-6 py-24 text-center text-ink-50">
        Loading…
      </div>
    );
  }

  if (!user) return <Navigate to="/sign-in" replace />;

  const isAdmin = profile?.role === 'admin' || profile?.role === 'super_admin';
  if (!isAdmin) return <Navigate to="/" replace />;

  return <>{children}</>;
}
